export default __webpack_public_path__ + "static/media/probation-outline-16px.46f7d102.svg";